const indexItems = [
  { title: '韩漫恋爱', desc: '契约婚姻·办公室恋情·校园初恋', icon: 'ri-heart-line', count: '1.2万部' },
  { title: '日漫热血', desc: '异世界冒险·剑与魔法·少年战斗', icon: 'ri-sword-line', count: '1.8万部' },
  { title: '国漫修仙', desc: '东方奇幻·古风仙侠·神话新编', icon: 'ri-magic-line', count: '8600部' },
  { title: '悬疑推理', desc: '侦探追踪·连环案件·心理博弈', icon: 'ri-search-eye-line', count: '5200部' },
  { title: '搞笑日常', desc: '轻松喜剧·校园日常·治愈系漫画', icon: 'ri-emotion-laugh-line', count: '9800部' },
  { title: '奇幻冒险', desc: '异世界穿越·魔法学院·史诗征程', icon: 'ri-compass-3-line', count: '7600部' },
  { title: '完结全集', desc: '已完结·一口气看完·经典回顾', icon: 'ri-check-double-line', count: '1.5万部' },
  { title: '新作上架', desc: '本周新上·热门新番·抢先试读', icon: 'ri-sparkling-line', count: '320部' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 text-center mb-8">
          主题索引
        </h2>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {indexItems.map((item) => (
            <a
              key={item.title}
              href="#"
              onClick={(e) => e.preventDefault()}
              className="flex items-start gap-3 p-4 rounded-xl bg-background-100/80 border border-background-200/70 hover:border-primary-200/50 hover:bg-primary-50/20 transition-all cursor-pointer group"
            >
              <div className="flex-shrink-0 w-9 h-9 rounded-lg bg-accent-100 flex items-center justify-center group-hover:bg-accent-200 transition-colors">
                <i className={`${item.icon} text-accent-600 text-sm`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5 line-clamp-1">{item.desc}</p>
                <p className="text-xs text-primary-600 font-medium mt-1">{item.count}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}